import $ from '@/util/jQuery';
import { getTeamAbbreviation } from '@/util/Parsing/Teams';
import { betweenParenthesis, toCamelCase } from '@/util/String';


/**
  Given a standard STHS HTML Output, will pull all the goals in the game
  @params html - The STHS HTML Output
*/
export function getGoalsFromHTMLOutput(html, teams){
  const output = [];
  let score = { [teams.home]: 0, [teams.visitor]: 0 }

  $(html)
    .find(".STHSBoxScore_PeriodPerPeriod_Header")
    .filter((_, el) => !['Shootout', 'Goalie Stats', '3 Stars', 'Official', 'Game Note', 'Finance'].includes(el.innerHTML))
    .each((_, el) => {
      const period = parsePeriodNumber(el.innerText);

      // Get text inside stats table pre.. filter out the BRs and the empty lines
      const goals = filterNonGoalText(Array.prototype.slice.call($(el).parent().next('tr').children('td')[0].childNodes));

      // Map the goals
      goals.forEach(node => {
        // Split up the text into variables
        let [team, playersTime] = node.textContent.split(' , ');
        team = findTeam(team);

        // Goal summary and time
        let [goalSummary, timeVariant] = playersTime.split(' at ');
        const { time, variant } = parseTimeAndVariant(timeVariant);
        const { scorer, assists } = parseScorerAndAssists(goalSummary);

        // Update Score
        score = {
          ...(output.length > 0 ? output[output.length - 1].score : score),
          [team]: (output.length > 0 ? output[output.length - 1].score[team] : score[team]) + 1
        }
        
        output.push({
          period: toCamelCase(period),
          team,
          score,
          time,
          variant,
          scorer,
          assists 
        });
      })
    })

    return output;
}

/**
  Given a period string, will create a better formatted period string
*/
function filterNonGoalText(textArr){
  return textArr.filter(node => {
    if(node.nodeName === "BR"){ return false }

    // Clean Up
    node.textContent = node.textContent.replace(/\n/g, '');

    // If empty, remove
    if(node.textContent === "" || node.textContent === 'No Goal'){ return false; }

    return true;
  })
}

/**
  Given a period string, will create a better formatted period string
*/
function parsePeriodNumber(str){
  // Base
  let period = str;

  // Need to match up this key with the OT key from the events
  // 1stOvertimePeriod, 2ndOvertimePeriod etc
  if(str.includes('Overtime')){
    const otNumber = str.split('#')[1];
    let variation;

    // Don't have to worry (I hope) for 20+ OTs so this will do
    switch(otNumber){
      case '1':
        variation = 'st';
        break;
      case '2':
        variation = 'nd';
        break;
      case '3':
        variation = 'rd';
        break;
      default:
        variation = 'th';
    };

    period = `${otNumber}${variation} Overtime Period`;
  }

  return period;
}

/**
 * Will find the team who scored the goal
 * Ex: 1. Avalanche
 * @param {string} teamStr 
 */
function findTeam(teamStr){
  const team = teamStr.split('. ');
  team.shift();
  return getTeamAbbreviation(team.join(' '));
}

function parseTimeAndVariant(str){
  let time;
  let variant = "EV";

  // If goals were (Empty Net), (PP) or (SH)
  // "18:13 (PP)"
  if(str.includes("(")){
    // [ "18:13", "(PP)"]
    let timeStr = str.split(' ');
    let [minutes, seconds] = timeStr[0].split(':');
    time = parseInt(minutes) * 60 + parseInt(seconds);

    // Get between the parentheseis
    variant = betweenParenthesis(timeStr.join(' '));

  } else{
    let [minutes, seconds ] = str.split(':');
    time = parseInt(minutes) * 60 + parseInt(seconds);
  }

  return { time, variant }
}


//"J.T. Miller 3 (Brett Pesce 2, Mark Stone 4)"
function parseScorerAndAssists(str){
  let [ goalScorer, assistStr ] = str.split('(');
  goalScorer = goalScorer.split(' ').filter(item => item !== "");

  // Total for the year
  const total = goalScorer.pop();

  const assists = assistStr
    .split(', ')
    .filter(item => item !== "")
    .map(item => item.replace(')', ''))
    .map(item => {
      let count = 1;
      let player = item.split(' ').filter(item => item !== "");

      // Weird thing where goalies getting assist don't have a count (GAME 222 YEAR 2017)
      // TODO.. known bug if goalie is like Jean Luc Picard (3 in the array but no count)
      if(player.length > 2){
        count = player.pop();
      }

      return {
        id: createPlayerId(player.join(" ")),
        total: parseInt(count)
      }
    })

    return {
      scorer: {
        id: createPlayerId(goalScorer.join(" ")),
        total: parseInt(total)
      },
      assists
    }
}

function createPlayerId(player){
  return toCamelCase(player.replace(/[^\w\s]/gi, ""));
}

export default {
  getGoalsFromHTMLOutput
}